export const profileValues = t => 
[
  {
    value: 'Develop',
    label: t('newsletter.form.profileValues.developer')
  },
  {
    value: 'Manager',
    label: t('newsletter.form.profileValues.manager')
  },
  {
    value: 'Affiliate',
    label: t('newsletter.form.profileValues.affiliate')
  },
  {
    value: 'Creator',
    label: t('newsletter.form.profileValues.creator')
  },
  {
    value: 'Other',
    label: t('newsletter.form.profileValues.other')
  }
]

export const OTHER_PROFILE = 'Other'